import styled from "styled-components";

export const StyledShortCodeLine = styled.p`
  margin: 0 0 14px;
  font-family: "Noto Sans Hebrew", sans-serif;
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  letter-spacing: -0.22px;
  color: #122243;
  text-align: center;

  strong {
    font-weight: 600;
    letter-spacing: inherit;
  }
`;
